import { useContext, useDebugValue } from "react";
import MemberContext from "../context/MemberProvider";

const useMember = () => {
    const { mem } = useContext(MemberContext);
    useDebugValue(mem, mem => mem?.user ? "Logged In" : "Logged Out")
    return useContext(MemberContext);
}

export default useMember;